module.exports = require('./script')

module.exports.Interpreter = require('./interpreter')
